<div class="flex-container" #divContamination (click)="onMouseClick($event)">
  <div class="singleLineForProgSettings">
    <div style="float:right;">
      <span>
        <fa-icon [icon]="faCog"></fa-icon>
      </span>
      <div class="btn" style="padding-top:0px;" data-backdrop="static" data-toggle="modal" data-target="#foProgramSetting">Program Settings</div>
    </div>
  </div>

  <div class="horizontalcard">
    <div class="formGroup">
      <label>Operating Conditions</label>
    </div>
    <div class="formGroup">
      <div class="row flex-wrapper">
        <div class="section">
          <div class="formGroup formRow">
            <div class="column">
              <label>Air Flow</label>
            </div>
            <div class="column">
              <input type="text" #txtAirflow [(ngModel)]="contamination.airflow" (focus)="onFocusEvent('Airflow', 0)" (keypress)="sharedService.validate($event)" (change)="detectKeyChanges('airflow', 0)" autocomplete="true" required style="width:100%; height:30px;">
              <datalist #datalistAirflow style="height:200px; width:100%; overflow-x:auto;">
                <option *ngFor="let item of airflowList" [ngValue]="item" >{{ item }}</option>
              </datalist>  
            </div>
            <div class="column">
              <label class="operatinglabels">{{contamination.airflowUnit}}</label>
            </div>
          </div>
          <div class="formGroup formRow">
            <div class="column">
              <label>Temperature</label>
            </div>
            <div class="column">
              <input type="text" #txtTemperature [(ngModel)]="contamination.temperature" (focus)="onFocusEvent('Temperature', 0)" (keypress)="sharedService.validate($event)" (change)="detectKeyChanges('temperature', 0)" autocomplete="true" required style="width:100%; height:30px;">
              <datalist #datalistTemperature style="height:200px; width:100%; overflow-x:auto;">
                <option *ngFor="let item of temperatureList" [ngValue]="item" >{{ item }}</option>
              </datalist>
            </div>
            <div class="column">
              <label class="operatinglabels">{{UnitsFromUserData.Temperature}}</label>
            </div>
          </div>
          <div class="formGroup formRow">
            <div class="column">
              <label>Relative Humidity</label>
            </div>
            <div class="column">
              <label class="operatinglabels">{{contamination.relativeHumidity}} %</label>
            </div>
            <div class="column">
              <!-- <label class="operatinglabels">{{contamination.relativeHumidity}} %</label>    -->
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

  <div class="title columnFlex">
    <div class="singleLine">
      <label>Contamination
        <img *ngIf="contamination.gasDetails.length < 3" (click)='addContamination()' src="assets/images/addBtn.png" style="width:55px;" class="pointer" id="AddContaminationInfoBtn" (mouseenter)="showHideInfoToggle('AddContaminationInfo')" (mouseleave)="showHideInfoToggle('AddContaminationInfo')">
        <div id="divAddContaminationInfo">
          <div class="InfoContent">
            Add a gas to the analysis.        
          </div>
          <div id="arrow" data-popper-arrow></div>
        </div>
      </label>           
    </div>
  </div>

  <div class="horizontalcard">
    <div class="formGroup">

  <!-- Add Contamination - Start -->
  <!-- <div class="addContaminationSection" (click)='addContamination()' *ngIf="contamination.gasDetails.length < 3">
    <div class="addContent">
      <span class="addClick">
        <span style="font-weight: 650; font-size:26px;">
            <fa-icon class="iconInformational pointer" [icon]="faInfoCircle" id="AddContaminationInfoBtn" (mouseenter)="showHideInfoToggle('AddContaminationInfo')" (mouseleave)="showHideInfoToggle('AddContaminationInfo')"></fa-icon>
              <div id="divAddContaminationInfo">
                  <div class="InfoContent">
                    Click on "Add Contamination" to add a gas to the analysis.
                    New Contamination will appear beside the current contamination.
                  </div>
                  <div id="arrow" data-popper-arrow></div>
              </div>
            Add  contamination <fa-icon [icon]="faPlus"></fa-icon> </span>
      </span>
    </div>
  </div> -->
  <!-- Add Contamination - End -->

      <div>
        <label>Application</label>
        <input type="text" #txtApplication [(ngModel)]="contamination.applicationType" (keyup)="search()" (focus)="onFocusEvent('Application', 0)" autocomplete="true" required style="width:24%; margin-left:4%;">
        <datalist #datalistApplication style="z-index:1;">
          <option *ngFor="let item of applicationList" [ngValue]="item.id" (click)="selectApplication(item)">{{ item.name }}</option>
        </datalist>
      </div>

      <div class="flex-nowrap row" style="margin-top:2%;margin-left:-3%;">
        <!-- <div id="divContamination" class="col-lg-5 col-md-5 col-sm-5 stagingfilter" *ngFor="let item of contamination.gasDetails; let i = index;"> -->
        <div id="divContamination" class="stagingfilter" style="width:30%;" *ngFor="let item of contamination.gasDetails; let i = index;">
          <div class="head">
            <span class="stage-span">
              <div class="stage">Contamination {{i+1}}</div>
            </span>
            <img *ngIf="i>0" (click)='removeFromGasDetails(i)' src="assets/images/trash_icon.png" style="width:22px;" class="pointer">
          </div>
          <div class="Filterbody">
            <div class="formGroup">
              <div class="formGroup double">
                <div>
                  <span>Type</span>
                  <!-- Modified by JW(2022-10-05): Contamination page, modified html and component.ts after downgrade to Angular v12-start -->
                  <!-- <input #txtContamination0 *ngIf="item.index == 0" type="text" [(ngModel)]='contaminationType1' (focus)="onFocusEvent('Contamination1', 0)" style="width:300px;">
                  <datalist #datalistContamination0 style="height:250px; overflow-x:auto;">
                    <option *ngFor="let gasList of contaminationList" [ngValue]="gasList.ChemicalID" (click)="selectContaminationType(gasList, 0)">{{ gasList.substance }}</option>
                  </datalist>
                  <button #btnOthers0 *ngIf="item.index == 0 && item.otherGas===true"(click)="openFormOthers(0)">
                    ...
                  </button> -->

                  <!-- <input  #txtContamination1 *ngIf="item.index == 1" type="text" [(ngModel)]='contaminationType2' (focus)="onFocusEvent('Contamination2', 1)" style="width:300px;">
                  <datalist #datalistContamination1 style="height:250px; overflow-x:auto;">
                    <option *ngFor="let gasList of contaminationList" [ngValue]="gasList.ChemicalID" (click)="selectContaminationType(gasList, 1)">{{ gasList.substance }}</option>
                  </datalist>
                  <button #btnOthers1 *ngIf="item.index == 1 && item.otherGas===true"(click)="openFormOthers(1)">
                    ...
                  </button> -->

                  <!-- <input  #txtContamination2 *ngIf="item.index == 2" type="text" [(ngModel)]='contaminationType3' (focus)="onFocusEvent('Contamination3', 2)" style="width:300px;">
                  <datalist #datalistContamination2 style="height:250px; overflow-x:auto; left:0px; top:0px;">
                    <option *ngFor="let gasList of contaminationList" [ngValue]="gasList.ChemicalID" (click)="selectContaminationType(gasList, 2)">{{ gasList.substance }}</option>
                  </datalist>
                  <button #btnOthers2 *ngIf="item.index == 2 && item.otherGas===true"(click)="openFormOthers(2)">
                    ...
                  </button> -->
                  <!-- Modified by JW(2022-10-05): filter dropdown list based on input entries -->
                  <input id="txtContamination{{i}}" type="text" (focus)="onFocusEvent('Contamination', i)" (keyup)="filterContaminationList(i)" style="width:300px;" autocomplete="off">
                  <datalist id="datalistContamination{{i}}" style="height:250px; overflow-x:auto;">
                    <option *ngFor="let gasList of contaminationList" [ngValue]="gasList.ChemicalID" (click)="selectContaminationType(gasList, i)">{{ gasList.substance }}</option>
                  </datalist>
                  <button #btnOthers0 *ngIf="item.index == 0 && item.otherGas===true"(click)="openFormOthers(0)">
                    ...
                  </button>
                  <button #btnOthers1 *ngIf="item.index == 1 && item.otherGas===true"(click)="openFormOthers(1)">
                    ...
                  </button>
                  <button #btnOthers2 *ngIf="item.index == 2 && item.otherGas===true"(click)="openFormOthers(2)">
                    ...
                  </button>
                  <!-- Modified by JW(2022-10-05): Contamination page, modified html and component.ts after downgrade to Angular v12-end -->
                </div>
              </div>
            </div>
            <div class="formGroup double">
              <div class="formGroup">
                <div>
                  <span>Concentration</span>
                  <div class="eff-col2">
                    <!-- <input id="txtConcentration{{inum}}" type="text" [(ngModel)]="contamination.gasDetails.concentrationValue" (change)="detectKeyChanges('Concentration')">  -->
                    <!-- <input id="txtConcentration{{i}}" type="text" [(ngModel)]="item.concentrationValue" (change)="detectKeyChanges('Concentration', item.index)"> -->
                    <input id="txtConcentration{{i}}" type="text" [(ngModel)]="item.concentrationValue" (change)="detectKeyChanges('Concentration', i)" (keypress)="sharedService.validate($event)">
                    <label class="operatinglabels">{{selectedConcUnit}}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="formGroup double">
              <div class="formGroup">
                <div>
                  <span class="pointer" (click)="moreInfo(item.index)"><img src="assets/images/expand.png" width="25px">{{item.displayTypeForMoreInfo}}</span>
                </div>
              </div>
            </div>
            <div class="formGroup double" style="width:95%;">
               <div id="divMoreInfoForGas{{i}}" class="moreInfoDisplay" style="width:100%; display:none;">
                  <table width="100%">
                    <tr>
                      <td width="60%">
                        <span class="moreInfoTitle">Chemical Formula</span>
                      </td>
                      <td width="40%">
                        <span class="moreInfoContents">{{item.moreInformation.chemicalFormula}}</span>
                      </td>
                    </tr>
                    <tr>
                      <td width="60%">
                        <span class="moreInfoTitle">Vapour Pressure</span>
                      </td>
                      <td width="40%">
                        <span class="moreInfoContents">{{item.moreInformation.vapourPressureValue}} {{UnitsFromUserData.VapourPa}}</span>
                      </td>
                    </tr>
                    <tr>
                      <td width="60%">
                        <span class="moreInfoTitle">Molecular Weight</span>
                      </td>
                      <td width="40%">
                        <span class="moreInfoContents">{{item.moreInformation.molecularWeight}} g/mol</span>
                      </td>
                    </tr>
                    <tr>
                      <td width="60%">
                        <span class="moreInfoTitle">Boiling Point</span>
                      </td>
                      <td width="40%">
                        <span class="moreInfoContents">{{item.moreInformation.boilingPoint}} {{UnitsFromUserData.Temperature}}</span>
                      </td>
                    </tr>
                    <tr>
                      <td width="60%">
                        <span class="moreInfoTitle">CAS No</span>
                      </td>
                      <td width="40%">
                        <span class="moreInfoContents">{{item.moreInformation.casNo}}</span>
                      </td>
                    </tr>
                  </table>
              </div>
            </div>
            <div class="formGroup double" style="width:95%;">
              <div id="divGasWarning{{i}}" style="display:none;">
                <table>
                  <tr>
                    <td>
                      <span id="spnGasWarningColor{{i}}" class="gasFontColor" style="font-weight:600;">Gas Warning</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span id="spnGasWarningDetColor{{i}}" class="gasFontColor">{{item.gasWarningDetail}}</span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Contamination button here -->

     
    </div>
  </div>

  <div class="modal fade" id="foProgramSetting" tabindex="-1" role="dialog" aria-labelledby="foCalculate" aria-hidden="true" >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="foProgramsetting">
        <div class="modal-content">
          <div class="modal-header">
            <span><h5 class="modal-title" id="progsettingpopup">Program Settings</h5></span>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)='triggerCancelFromProgSettings()' style="margin-right:5%;background-color: white; border: none;">
                <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="width:450px;">
                  <div class="formGroup formRow">
                      <div class="formGroup">
                        <label>Unit (SI / US)</label>
                        <!-- <select [(ngModel)]="userUnit"  class="dropdown-modify"> -->
                        <select [(ngModel)]="selUnitFromProgSettings" (change)="toggleUnit()" class="dropdown-modify">
                            <option disabled selected value=''></option>
                            <option *ngFor="let item of unitlist" [ngValue]="item.value">{{item.display}}</option>
                        </select>
                      </div>
                  </div>
                  <div class="formGroup formRow">
                    <div class="formGroup">
                      <label>Concentration (ppb / mg/m³)</label>
                      <!-- <select [(ngModel)]="selConcUnit" class="dropdown-modify"> -->
                      <select [(ngModel)]="selConcUnitFromProgSettings" class="dropdown-modify">
                          <option disabled selected value=''></option>
                          <option *ngFor="let item of concUnitlist.List" [ngValue]="item">{{item}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="formGroup formRow">
                    <div class="formGroup">
                      <label>Airflow (m³/h / CFM / m³/s / L/s)</label>
                      <!-- <select [(ngModel)]="selConcUnit" class="dropdown-modify"> -->
                      <select [(ngModel)]="selAirFlowUnitFromProgSettings" [disabled]="disableFlag" class="dropdown-modify">
                          <option disabled selected value=''></option>
                          <option *ngFor="let item of airFlowUnitlist.List" [ngValue]="item">{{item}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="btnGroupPrgSetting">
                    <div class="cancel pointer" data-dismiss="modal" (click)='triggerCancelFromProgSettings()'>Cancel</div>
                    <div class="next-button-content">
                            <button class="button-content ripple" data-dismiss="modal" (click)='triggerDoneFromProgSettings()'>
                            <span class='space'>Done</span>
                        </button>
                    </div>
                </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="next-button-content">
    <button class="button-content ripple" (click)='next()'>
        <span class='space'>Next</span> <fa-icon [icon]="faAngleRight"></fa-icon>
    </button>
  </div>
</div>

<ng-template #selectOtherGasPopUp let-modal class="selectOtherGasPopUp">
  <div class="otherGasPopUp" (click)="onMouseClick($event)">
    <div class="modal-content">
      <div class="modal-header">
        <div class="head-1">
          <span><h5 style="margin-left:-15px;" class="modal-title" id="exampleModalLongTitle">Other Gas Details</h5></span>
          <button type="button" class="close forceCloseOtherGasPopUp" data-dismiss="modal" aria-label="Close" (click)="modal.dismiss(true); forceClose()">
              <span aria-hidden="true">&times;</span>
          </button>
          <button type="button" class="finalClose" data-dismiss="modal" aria-label="Close" #closeBtn>Close</button>
        </div>
        <div class="head-2">
          <div class="popupContent">
            <div>
              <label style="margin-left:-15px;">Other Contamination</label>
              <input id="txtOtherGas" type="text" [(ngModel)]='OtherGasName'(focus)="onFocusEvent('OtherContamination', 9)" style="width:300px; margin-left:50px;">
              <datalist id="datalistOtherGas" style="height:250px; overflow-x:auto;">
                <option *ngFor="let otherGasList of otherGassesList" [ngValue]="otherGasList.ID" (change)="selectOtherGas(otherGasList)">{{ otherGasList.substance }}</option>
              </datalist>
            </div>
            <div style="margin-top:20px;">
              <label style="margin-left:-15px;">Chemical Formula</label>
              <input id="txtOtherGasChemFormula" type="text" [(ngModel)]='OtherGasChemFormula' style="width:300px; margin-left:73px;" (change)="detectKeyChanges('OtherGasChemFormula', 0)">
            </div>
            <div style="margin-top:20px;">
              <label style="margin-left:-15px;">Density [g/cm³]</label>
              <input id="txtOtherGasDensity" type="text" [(ngModel)]='OtherGasDensity' style="width:300px; margin-left:90px;" (change)="detectKeyChanges('OtherGasDensity', 0)" (click)="sharedService.checkIfZero($event)">
            </div>
            <div style="margin-top:20px;">
              <label style="margin-left:-15px;">Molecular Weight [g/mol]</label>
              <input id="txtOtherGasMolWeight" type="text" [(ngModel)]='OtherGasMolWeight' style="width:300px; margin-left:18px;" (change)="detectKeyChanges('OtherGasMolWeight', 0)" (click)="sharedService.checkIfZero($event)">
            </div>
            <div style="margin-top:20px;">
              <label style="margin-left:-15px;">Boiling Point [{{UnitsFromUserData.Temperature}}]</label>
              <input id="txtOtherGasBoilingPoint" type="text" [(ngModel)]='OtherGasBoilingPoint' style="width:300px; margin-left:82px;" (change)="detectKeyChanges('OtherGasBoilingPoint', 0)" (click)="sharedService.checkIfZero($event)">
            </div>
            <div style="margin-top:20px;">
              <label style="margin-left:-15px;">Refractive Index</label>
              <input id="txtOtherGasRefractiveIndex" type="text" [(ngModel)]='OtherGasRefractiveIndex' style="width:300px; margin-left:88px;" (change)="detectKeyChanges('OtherGasRefractiveIndex', 0)" (click)="sharedService.checkIfZero($event)">
            </div>
            <div style="margin-top:20px;">
              <label style="margin-left:-15px;">Vapour Pressure [{{UnitsFromUserData.VapourPa}}]</label>
              <input id="txtOtherGasVapourPressure" type="text" [(ngModel)]='OtherGasVapourPressure' style="width:300px; margin-left:37px;" (change)="detectKeyChanges('OtherGasVapourPA', 0)" (click)="sharedService.checkIfZero($event)">
            </div>
          </div>
        </div>
      </div>
      <div class="modal-body" style="padding-top:0px;">
        <div>
          <div class="btnGroup">
            <div class="cancel pointer" data-dismiss="modal" (click)="modal.dismiss(true); forceClose()" aria-label="Close" >Cancel</div>
            <div class="next-button-content">
              <button class="button-content ripple" (click)='confirmOtherGasSelection()' aria-label="Close">
                <span class='space'>Done</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

